import {HttpInterceptorFn} from '@angular/common/http';
import {getTraceData} from '@sentry/angular';

import {environment} from '../../environments/environment';

/**
 * Sends Sentry's `sentry-trace`/`baggage` to our API only, so the backend continues the trace and
 * its errors share a trace id with the app's (homey-sentry). Empty while Sentry is off. Not
 * `browserTracingIntegration`: it would also start web-vitals observers, interaction listeners
 * and page-load spans for the whole session, none of which we use.
 */
export const sentryTraceInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }
  const {'sentry-trace': sentryTrace, baggage} = getTraceData();
  if (sentryTrace === undefined) {
    return next(req);
  }
  return next(req.clone({setHeaders: {'sentry-trace': sentryTrace, ...(baggage === undefined ? {} : {baggage})}}));
};
